import { render, staticRenderFns } from "./PrintTechnique.vue?vue&type=template&id=67639a9b"
import script from "./PrintTechnique.vue?vue&type=script&lang=ts"
export * from "./PrintTechnique.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PrintTechnique.vue?vue&type=style&index=0&id=67639a9b&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports